module.exports = __webpack_public_path__ + "img/i.ee4d68f9.jpg";